import * as T from 'components/ui/typography'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

interface CreditProps {
    creditData?: CreditDataTypes
    unlimited?: boolean
    path: string
}

const CreditTooltip = React.memo<CreditProps>(({ creditData, unlimited, path }) => {
    const sectionName = () => {
        if (path === 'simulations') return 'Simulazioni'
        if (path === 'quiz') return 'Quiz'
        if (path === 'duels') return 'Sfide'
    }
    const { t } = useTranslation('header')

    return (
        <div className="flex flex-col gap-4">
            <div className="flex justify-between items-center mb-1">
                <div className="flex flex-col gap-1 items-start" style={{ flex: 0.7 }}>
                    <h1 className="font-xl font-bold "> {t('credit.credits') + ' ' + sectionName()}</h1>
                    <T.Small className="font-semibold">{t('credit.creditInPlan.title')}</T.Small>
                    <T.Small className="text-xs">
                        {t('credit.creditInPlan.description', { credit: creditData?.creditPerDay || 0 })}
                    </T.Small>
                </div>
                <T.Small>
                    <>{unlimited ? t('credit.unlimited') : creditData?.creditInPlan}</>
                </T.Small>
            </div>
            <div className="flex justify-between gap-1 items-center">
                <div className="flex flex-col items-start" style={{ flex: 0.7 }}>
                    <T.Small className="font-semibold">{t('credit.creditNoExp.title')}</T.Small>
                    <T.Small className="text-xs">{t('credit.creditNoExp.description')}</T.Small>
                </div>
                <T.Small>
                    <>{unlimited ? t('credit.unlimited') : creditData?.creditOutPlan}</>
                </T.Small>
            </div>
        </div>
    )
})
export default CreditTooltip
